import { inject, Injectable, signal } from '@angular/core';
import {
  SupplyDrop,
  SupplyDropInformation,
  SupplyDropState,
} from './interfaces/supply-drop.interface';
import { SocketService } from '@core/services/socket.service';
import { sleep } from '@core/utils/sleep.util';
import { ChatService } from '@features/layout/chat/services/chat.service';

@Injectable({
  providedIn: 'root',
})
export class SupplyDropService {
  private readonly socketService = inject(SocketService);
  private readonly chatService = inject(ChatService);

  supplyDrop = signal<SupplyDropState>({
    status: 'none',
    supplyDrop: null,
    supplyDropInformation: null,
    captcha: null,
    players: 0,
  });

  constructor() {
    // TODO: Remove debug helpers before committing
    (window as any).__testSupplyDropStart = () => {
      this.chatService.addSupplyDropStartMessage({
        name: 'Bronze V Case',
        link: 'bronze-v',
        image: 'assets/images/cases/3_bronze/bronze_5.png',
        price: 0,
        tier: 3,
        category: 'bronze',
        skins: [],
      });
    };

    (window as any).__testSupplyDropEnd = () => {
      this.chatService.addSupplyDropEndMessage({
        winner: {
          steamid: '123',
          name: 'TestPlayer',
          avatar:
            'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/fe/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg',
        },
        case: {
          name: 'Bronze V Case',
          link: 'bronze-v',
          image: '',
          price: 0,
          tier: 3,
          category: '',
          skins: [],
        },
        result: [{ skin: 'Test Skin', price: 1.5 }] as any,
        avatars: ['a', 'b', 'c', 'd', 'e'],
        gameid: 'test-game-123',
        ticket: 42,
        ticketPercentage: 15.3,
        winneravatar: '',
        winnername: 'TestPlayer',
        timestamp: 0,
        message: '',
        winnerid: 0,
      });
    };

    this.socketService.socket.on(
      'update_captcha',
      (data: { captcha: string }) => {
        this.supplyDrop.update((prev) => ({
          ...prev,
          captcha: data.captcha,
        }));
      }
    );
    this.socketService.socket.on(
      'start_drop',
      async (data: SupplyDropInformation) => {
        this.supplyDrop.update((prev) => ({
          ...prev,
          supplyDropInformation: data,
          status: 'running',
          players: 0,
        }));
        await sleep(500);
        this.chatService.addSupplyDropStartMessage({
          name: data.skin_name,
          link: data.skin_name.toLowerCase().replace(/\s+/g, '-'),
          image: data.image,
          price: data.price,
          tier: data.type,
          category: '',
          skins: [],
        }, data.message);
      }
    );

    this.socketService.socket.on(
      'update_drop_players',
      (data: { players: number }) => {
        this.supplyDrop.update((prev) => ({
          ...prev,
          players: data.players,
        }));
      }
    );

    this.socketService.socket.on('end_drop', (data: SupplyDrop) => {
      this.supplyDrop.update((prev) => ({
        ...prev,
        supplyDrop: data,
        status: 'rolling',
      }));
    });
  }

  public postEndMessage(data: SupplyDrop) {
    this.chatService.addSupplyDropEndMessage(data);
  }

  public async joinSupplyDrop(captcha: string) {
    const res = await this.socketService.emit('join_drop', {
      captcha: captcha,
    });
    return res;
  }
}
